<div
  class="{{ textType }}-{{ textSize }}"
  [class.uppercase]="uppercase"
  [class.initial-case]="initialCase"
  [class.user-select-text]="canCopy"
  [tabindex]="canCopy ? -1 : undefined"
>
  {{ text }}<ng-content></ng-content>
</div>
